<template>
	<div>
		<div v-if="debug">
			<div>
				<b-card
					header-tag="header"
					v-for="(item, name, indexgroup) in device"
					:key="indexgroup"
				>
					<template #header>
						<h6 class="mb-0">{{name}}</h6>
					</template>
					<b-card-text class="json">
						<code>{{ item }}</code>
					</b-card-text>
				</b-card>
			</div>
		</div>

		<div v-if="login == false" class="screen_middle_center">
			<b-spinner
				variant="primary"
				style="width: 3rem; height: 3rem;"
			></b-spinner>
		</div>
		<b-card
			v-else
			no-body
			header-tag="header"
			class="mb-2"
			v-for="(item, name, indexgroup) in device"
			:key="indexgroup"
		>
			<template #header>
				<h4 class="m-0 p-0">{{ name }}</h4>
			</template>
			<b-list-group
				:class="['m-2', { 'mt-0': indexbox != 0 }]"
				v-for="(prop, id, indexbox) in item"
				:key="indexbox"
			>
				<div v-if="Object.keys(prop).length">
					<b-list-group-item class="p-3" v-if="prop.type == 'relay'">
						<IconWifi :wifi="prop.wifi" />
						<h5>{{ prop.name }}</h5>
						<b-button
							:variant="prop.state == 'on' ? 'success' : 'danger'"
							:disabled="prop.disabled == true"
							@click="
								callAction({
									name: name,
									id: id,
									state: prop.state == 'on' ? 'off' : 'on',
									time: prop.default_time_value,
								})
							"
						>
							<v-icon :name="prop.icon" scale="2" />
						</b-button>

						<!-- Subbuttons here... -->
						<b-button
							v-for="(button, i) in prop.SubButtons"
							:key="i"
							:variant="button.state == 'on' ? 'success' : 'danger'"
							class="m-2"
							:disabled="prop.disabled == true"
							@click="
								ActionSubButton({
									id: id,
									SubButton: i,
								})
							"
						>
							<v-icon :name="button.icon" scale="2" />
						</b-button>

						<!-- Čas zapinání... -->
						<div
							class="p-3"
							v-if="prop.times && prop.time == 0 && prop.disabled == false && prop.state == 'off'"
						>
							<b-button
								v-for="(button, time) in prop.times"
								:key="time"
								variant="danger"
								class="m-2 p-0 btn-lg"
								@click="
									callAction({
										name: name,
										id: id,
										state: prop.state == 'on' ? 'off' : 'on',
										time: time,
									})
								"
							>
								{{ button }}
							</b-button>
						</div>

						<!-- Výpis zbývajícího času... -->
						<p v-if="prop.times && prop.time > 0" class="mb-0 mt-3">
							Time remaining {{ getTimeRelay(prop.time) }}
						</p>
					</b-list-group-item>

					<b-list-group-item class="p-3" v-else-if="prop.type == 'temp'">
						<IconWifi :wifi="prop.wifi" />
						<h5>{{ prop.name }}</h5>
						<p>Teplota {{ prop.value }} °C</p>

						<TempGraph :data="prop.data" v-if="prop.data" />
					</b-list-group-item>
				</div>

				<div v-else>
					<b-list-group-item>
						<b-spinner variant="warning"></b-spinner><br />
						{{ id }}
					</b-list-group-item>
				</div>
			</b-list-group>
		</b-card>
	</div>
</template>

<script>
import IconWifi from "@/components/IconWifi.vue";
import TempGraph from "@/components/TempGraph.vue";

import websocket from "../websocket.js";

export default {
	name: "Main",
	components: {
		IconWifi,
		TempGraph,
	},
	methods: {
		getTimeRelay: function(time) {
			time = parseInt(time);

			if (time < 60) {
				return `${time}s`;
			} else if (time < 3600) {
				return `${Math.floor(time / 60)}m ${time -
					Math.floor(time / 60) * 60}s`;
			} else if (time >= 3600) {
				var hod = Math.floor(time / 60 / 60);
				var min = Math.floor((time - hod * 60 * 60) / 60);
				var sec = time - hod * 60 * 60 - min * 60;
				return `${hod}hod ${min} min ${sec}s`;
			}
		},

		ActionSubButton: function(data) {
			console.log("Clicked SubButton action", data);

			this.websocket.sendMessage(
				Object.assign(data, {
					action: "action",
				})
			);
		},

		callAction: function(data) {
			console.log("Clicked action", data);

			if (data.state == "off") {
				data.time = 0;
			}

			this.device[data["name"]][data["id"]].state = data["state"];
			this.device[data["name"]][data["id"]].time = data["time"];

			this.websocket.sendMessage({
				action: "action",
				id: data["id"],
				state: data["state"],
				time: data["time"],
			});
		},
	},

	created: function() {
		console.log("Component created...");

		this.websocket = websocket.websocket(
			(message) => {
				// onMessage
				try {
					let data = JSON.parse(message);
					if (data.action == "update") {
						this.device = data.data;
						this.login = true;
					}
					console.log("Got this message", message);
				} catch {
					console.log("Error by parsing JSON", message);
				}
			},
			() => {
				// onConnect
				const url = new URLSearchParams(window.location.search);

				this.websocket.sendMessage({
					action: "login",
					user: url.get("username"),
					password: url.get("password"),
				});
				this.websocket.sendMessage({
					action: "get_register",
				});
				this.websocket.sendMessage({
					action: "get_udpate",
				});
				console.log("Shut send login");
			},
			() => {
				// onClose
				this.login = false;
			}
		);

		this.timer = setInterval(() => {
			// console.log("timmer called... auto decrement...", this.device);
			for (let box in this.device) {
				for (let item in this.device[box]) {
					let cfg = this.device[box][item];

					if (cfg.time > 1) {
						cfg.time--;
					} else if (cfg.time == 1) {
						cfg.time = 0;
						cfg.state = "off";
					}
					// console.log("Looping item", cfg);
				}
			}
		}, 1000);

		// Add debug here...
		window.addEventListener("keydown", (e) => {
			if (e.code == "KeyD") {
				this.debug = !this.debug;
			}
		});
	},

	data: function() {
		return {
			login: false,
			debug: false,
			device : {
				
			}
		// 	device: {
		// 		"Doma box": {
		// 			"hilgard_nuki.dvere": {
		// 				icon: "door-closed",
		// 				name: "Vstupní dvěře",
		// 				wifi: 80,
		// 				default_time_value: 0,
		// 				hasTimeInterval: false,
		// 				type: "relay",
		// 				state: "off",
		// 				disabled: false,
		// 				time: 2,
		// 			},
		// 			"hilgard_zvonek.zvonek": {
		// 				icon: "dungeon",
		// 				name: "Zvonek",
		// 				wifi: 60,
		// 				default_time_value: 0,
		// 				hasTimeInterval: false,
		// 				type: "relay",
		// 				state: "on",
		// 				disabled: true,
		// 				times: {
		// 					"900": "15m",
		// 					"3600": "1h",
		// 					"7200": "2h",
		// 				},
		// 				time: 3600,
		// 			},
		// 			"hilard.bazen.teplota": {
		// 				name: "Teplota vody",
		// 				wifi: 30,
		// 				value: "14.69",
		// 				type: "temp",
		// 				data: {
		// 					"6:00": 20,
		// 					"7:00": 30,
		// 					"8:00": 40,
		// 					"9:00": 25,
		// 					"10:00": 50,
		// 				},
		// 			},
		// 			"hilgard_brana.brana": {
		// 				icon: "torii-gate",
		// 				name: "Brána",
		// 				wifi: 50,
		// 				type: "relay",
		// 				SubButtons: [
		// 					{
		// 						icon: "walking",
		// 						state: "off",
		// 					},
		// 				],
		// 			},
		// 		},
		// 	},
		};
	},
};
</script>

<style scoped>



</style>
